// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tYsF3","type":"styles_type__2TjxC","choices":"styles_choices__12BKR"};